( function( $ ) {
	$( document ).ready( function() {

		var $table = $( '.ranking-section__table-wrapper .table' );
		if ( !$table.length ) { return; }

		var showRows = $table.data( 'show-rows' ) || 25;

		var $btn = $table.next( '.table__expand-btn' );
		var originalText = $btn.text();
		var secondaryText = $btn.data( 'less' );

		var $tableBody = $table.find( 'tbody' );
		var $tableBodyRow = $tableBody.find( 'tr' );

		$tableBodyRow.hide();
		$tableBody.find( 'tr:lt(' + showRows + ')' ).show();

		$btn.on( 'click', function() {
			if ( $tableBody.find( 'tr:visible' ).length <= showRows ) {
				$tableBodyRow.show();
				$( this ).text( secondaryText );
			} else {
				$tableBodyRow.hide();
				$tableBody.find( 'tr:lt(' + showRows + ')' ).show();
				$( this ).text( originalText );
			}
		} );
	} );
} )( jQuery );